import React from 'react';
import styles from './NoPermission.module.scss';

export const NoPermission = () => {
  return (
    <div className={styles.container}>
      You do not have permission to access the requested resource.<br/>
      Please log-in using a valid user and try again.
    </div>
  );
};
